//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CategoriasAPI from "@/api/promotores/cursos/categorias.api";
import CategoriaForm from "./CategoriaForm";

export default {
  data() {
    return {
      loading: true,
      categorias: [],
    };
  },

  mounted() {
    this.loadCategorias();
  },

  methods: {
    async loadCategorias() {
      try {
        this.loading = true;
        this.categorias = await CategoriasAPI.all();
      } finally {
        this.loading = false;
      }
    },

    crearCategoria() {
      this.$q
        .dialog({
          component: CategoriaForm,
        })
        .onOk((categoria) => {
          this.loadCategorias();
        });
    },

		editarCategoria(categoria) {
			this.$q
        .dialog({
          component: CategoriaForm,
					categoria
        })
        .onOk((categoria) => {
          this.loadCategorias();
        });
		}
  },
};
